import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { StorageService } from 'src/app/services/storage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FormDataFacade } from 'src/app/ngrx/form-data/form-data.facade';
import { ApsAssignedFacade } from 'src/app/ngrx/aps_assinged/aps_assinged.facade';
import { Network } from '@ngx-pwa/offline';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LogoutModalComponent } from '../logout-modal/logout-modal.component';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  selectedParticipant = this.storage.getSessionValue('participantID');
  @Input() sections = [];
  @Output() hideSideNav: EventEmitter<any> = new EventEmitter();
  isOpen = false;
  selectedSection = 'intake-reports/';
  selectedMainSection = '/report-list';
  selectedSubSection = '';
  selectedCaseNumber = 0;
  participanName = '';
  online$ = this.network.online;
  bsModalRef: BsModalRef;
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private storage: StorageService,
    private fdFacade: FormDataFacade,
    private apsFacade: ApsAssignedFacade,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private global: GlobalService,
    protected network: Network
  ) { }

  ngOnInit() {
    this.global.checkUserIdle();
    this.network.onlineChanges.subscribe(
      online => this.online$ = online
    );
    const apsReportLoadId = this.storage.getLocalValue('selectedID');
    this.selectedSubSection = this.storage.getSessionValue('subSection');
    this.selectedSection = this.storage.getSessionValue('openedSection');
    console.log('selectedMainSection', this.storage.getSessionValue('selectedMainSection'));
    if (this.storage.getSessionValue('selectedMainSection') !== undefined && this.storage.getSessionValue('selectedMainSection') !== null) {
      this.selectedMainSection = this.storage.getSessionValue('selectedMainSection');
    }
    const assignedAgentId = +this.storage.getLocalValue('selectedAssignedAgentId');
    this.apsFacade.getApsAssignedCheckOutList(assignedAgentId, [apsReportLoadId]).subscribe(
      doc => {
        doc.map(
          data => {
            this.selectedCaseNumber = data.aps_case_load_id;
            this.participanName = `${data.victim_last_name}, ${data.victim_first_name}`;
            this.online$ = this.network.online;
          }
        );
      }
    );
  }

  redirectSection(section: string, subSection: string, name: string) {
    this.storage.setSessionValue('openedSection', name);
    this.storage.setSessionValue('subSection', subSection);
    this.router.navigate(['/intake-reports/section/', section, subSection]);
    this.selectedSection = name;
    this.selectedSubSection = subSection;
    const apsReportLoadId = this.storage.getLocalValue('selectedID');
    const assignedAgentId = +this.storage.getLocalValue('selectedAssignedAgentId');
    this.fdFacade.fetchFormData(apsReportLoadId, assignedAgentId);
    if (window.screen.width < 576) {
      this.hideSideNav.emit();
    }
  }

  redirectMainSection(section: string) {
    this.storage.setSessionValue('selectedMainSection', section);
    this.selectedMainSection = section;
    this.router.navigate([section]);
  }

  logout() {
    const initialState = {};
    this.modalService.config.ignoreBackdropClick = true;
    this.modalService.config.class = 'modal-lg';
    this.bsModalRef = this.modalService.show(LogoutModalComponent, {initialState});
  }

  openSection(section) {
    const openedSection = this.storage.getSessionValue('openedSection');
    return openedSection === section;
  }

}
